import React, {useEffect} from 'react';
import axios from "src/api/axiosInstance";
import {getToken} from "src/tokenStorage";
import useAuth from "src/hooks/use-auth";

const AxiosInitialConfigurer = ({ children }) => {
  const { onLogout } = useAuth();

  const setAxiosDefaults = () => {
    const rootElement = document.querySelector('#senso-account-root');
    let apiBaseUrl = rootElement.getAttribute('data-api-base-url');
    while (apiBaseUrl.slice(-1) === '/') {
      apiBaseUrl = apiBaseUrl.slice(-1);
    }

    axios.defaults.baseURL = apiBaseUrl;
    axios.defaults.headers = {
      Accept: 'application/ld+json',
      'Content-Type': 'application/ld+json',
    };
    axios.interceptors.request.use((config) => {
      const token = getToken();
      if (config && token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    })
    axios.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      // For a 401, the token is expired, so we should redirect to login
      if (401 === error.response.status) {
        const requestUrl = error.config.url;

        // If we are logging in but are getting a 401, wrong credentials have been entered
        // Do nothing, this is not the interceptor's responsibility
        if (requestUrl === '/token/login') {
          return Promise.reject(error);
        }

        // Log the user out and redirect to login
        onLogout();

        return Promise.reject(error);
      }

      return Promise.reject(error);
    })
  }

  useEffect(() => {
    setAxiosDefaults();
  }, [])

  return (
    <>
      {children}
    </>
  );
}

export default AxiosInitialConfigurer;

AxiosInitialConfigurer.propTypes = {}

AxiosInitialConfigurer.defaultProps = {}